export const MAIN_CLASS_NAME = 'agent-relation-modal';
export const TITLE_CLASS_NAME = `${MAIN_CLASS_NAME}__title`;
export const FORM_ITEM_CLASS_NAME = `${MAIN_CLASS_NAME}__form-item`;
